import { Box, Button, Flex } from "@chakra-ui/react";
import React from "react";
import { AiFillLinkedin, AiOutlineGithub } from "react-icons/ai";
import { Link } from "react-router-dom";

function Contact() {
  return <Box id="contact"></Box>;
}

export default Contact;
